import React from 'react';

const bindemittelOptions = [
  "30/45",
  "50/70",
  "70/100",
  "160/220",
  "10/40-65 A",
  "40/100-65 A",
  "25/55-55 A",
  "45/80-50 A",
  "15/25 VL",
  "15/25 VH",
  "25/35 VL",
  "25/35 VH",
  "35/50 VL",
  "35/50 VH",
  "50/80 VL",
  "50/80 VH",
  "PmB 10/25 VL",
  "PmB 10/25 VH",
  "PmB 25/45 VL",
  "PmB 25/45 VH",
  "PmB 50/80 VL",
  "PmB 50/80 VH"
];

const BindemittelSelect = ({ value, onChange, className }) => {
  const defaultClassName = "w-full p-3 bg-gray-50 border border-gray-100 rounded-xl appearance-none cursor-pointer text-gray-600 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all";

  return (
    <div className="relative">
      <select
        value={value}
        onChange={onChange}
        className={className || defaultClassName}
      >
        <option value="" disabled>Bindemittel auswählen</option>
        {bindemittelOptions.map((type) => (
          <option key={type} value={type}>
            {type}
          </option>
        ))}
      </select>
      <div className="absolute inset-y-0 right-0 flex items-center px-3 pointer-events-none">
        <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
        </svg>
      </div>
    </div>
  );
};

export default BindemittelSelect;